<template>
  <b-form-group
    label="Nama Barang"
    label-for="namaBarang"
    label-class="pb-0 pt-0"
  >
    <b-form-input
      v-model="namaBarang"
      disabled
    />
  </b-form-group>
</template>
<script>
export default {
  props: {
    namaBarang: { type: String, default: '' },
  },
}
</script>
